import axios from 'axios';
import { ROLE } from '../interface/interface';

export const userDetails = async (access_token: string | undefined) => {
  try {
    const response = await axios.get(
      `${process.env.AUTHENTIK_HOST}/application/o/userinfo/`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${access_token}`,
        },
      },
    );

    return {
      name: response.data.name,
      email: response.data.email,
      role: userRole(response.data.groups),
    };
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Since a user can only be in one role, returns their highest role.
 *
 * @param roles
 * @returns
 */
const userRole = (roles: ROLE[]) => {
  if (!Array.isArray(roles)) return roles;

  let role = ROLE.Patients;

  if (roles?.includes(ROLE.Doctors)) role = ROLE.Doctors;
  if (roles?.includes(ROLE.PLO)) role = ROLE.PLO;
  if (roles?.includes(ROLE.Dispense_Tech)) role = ROLE.Dispense_Tech;
  if (roles?.includes(ROLE.Admin)) role = ROLE.Admin;
  if (roles?.includes(ROLE.Pharmacist)) role = ROLE.Pharmacist;

  return role;
};
